export default __webpack_public_path__ + "static/media/Slider7.d1769c9e.jpg";